module.exports = __webpack_public_path__ + "img/Mudah.f8d893ae.png";